import React from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

export default class data extends React.Component {
    state ={
        data1 : "",
        products:[],
        
    }
    addData = data => {
        switch (data.target.name) {
            case "data1": this.setState({data1:data.target.value});break;
            default:
                break;
        }
    }

    setRow = (count) =>{
        var data = [];
        for(var i = 0 ;i <= count-1 ;i++){
            data[i] = {
                C0 : i+1,
                C1 : "",
                C2 : "",
                C3 : "",
                C4 : "",
                C5 : "",
                C6 : "",
                C7 : "",
                C8 : "",
                C9 : "",
                C10 : "",
                C11 : "",
            }
            
        }
        this.setState({products:data});
    }
    componentDidMount(){
        this.setRow(10);
    }
    render() {
        const cellEditProp = {
            mode: 'click',
            blurToSave: true,
            beforeSaveCell: this.onBeforeSaveCell,
            afterSaveCell: this.onAfterSaveCell,
            
        };
        return (
            <div class={this.props.CustomerData.showResults === "3" ? '':"CustomerHidden" }>
                <div class="container" align="center">
                <BootstrapTable
                    data={ this.state.products }
                    cellEdit={ cellEditProp} 
                >
                    <TableHeaderColumn dataField='C0' isKey width="40" dataAlign="center"> </TableHeaderColumn>
                    <TableHeaderColumn dataField='C1' editable > รหัส </TableHeaderColumn>
                    <TableHeaderColumn dataField='C2' editable > ชื่อผู้ติดต่อ </TableHeaderColumn>
                    <TableHeaderColumn dataField='C3' editable > หมายเลขสมาชิก </TableHeaderColumn>
                    <TableHeaderColumn dataField='C4' editable >  ที่อยู่ </TableHeaderColumn>
                    <TableHeaderColumn dataField='C5' editable > โทรศัพท์ </TableHeaderColumn>
                    <TableHeaderColumn dataField='C6' editable > อีเมล์ </TableHeaderColumn>
                    <TableHeaderColumn dataField='C7' editable > ศาสนา </TableHeaderColumn>
                    <TableHeaderColumn dataField='C8' editable > การศึกษา </TableHeaderColumn>
                    <TableHeaderColumn dataField='C9' editable > ตำแหน่งในองค์กร </TableHeaderColumn>
                    <TableHeaderColumn dataField='C10' editable > ตำแหน่งสังคม </TableHeaderColumn>
                    <TableHeaderColumn dataField='C11' editable > วันเกิด </TableHeaderColumn>
                </BootstrapTable>
                </div>
            </div>
        )
    }
}
